import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../../styles/Colors";
import rem from "../../../utils/rem";
const Text = styled.span `
  color: inherit;
  margin-right: 0.75rem;
  ${({ maxLines }) => maxLines &&
    css `
      display: -webkit-box;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;
const StyledIconTextButton = styled.button `
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  margin: 0;
  line-height: 1.5;
  ${({ size }) => size === "large" &&
    css `
      font-size: ${rem(16)};
      letter-spacing: ${rem(0.4)};
      font-weight: 500;
    `}
  ${({ size }) => size === "medium" &&
    css `
      font-size: ${rem(14)};
      letter-spacing: ${rem(0.4)};
    `}
  ${({ size }) => size === "small" &&
    css `
      font-size: ${rem(12)};
    `}

    &:focus {
    outline: none;
  }

  ${Text} {
    ${({ withShadow }) => withShadow &&
    css `
        border-bottom: 0.5px solid ${Colors.PROFILE_RED_2024};
      `}
  }

  svg {
    fill: ${Colors.BLACK};
  }
  &:hover {
    ${Text} {
      border-bottom: 0.5px solid ${Colors.PROFILE_RED_2024};
    }
  }

  &[disabled] {
    cursor: default;
    color: ${Colors.GRAY};
    ${Text} {
      box-shadow: none;
      cursor: not-allowed;
    }

    svg {
      fill: ${Colors.GRAY};
    }
  }
`;
const Content = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    position: relative;
    top: -1px;
  }
`;
export const IconTextButton = React.memo(({ children, title, icon, onClick, disabled, size = "large", maxLines, withShadow = true, }) => {
    const Icon = icon;
    return (React.createElement(StyledIconTextButton, { size: size, title: title, type: "button", onClick: onClick, disabled: disabled, withShadow: withShadow },
        React.createElement(Content, null,
            React.createElement(Text, { maxLines: maxLines }, children),
            Icon && React.createElement(Icon, { width: 24, height: 24 }))));
});
IconTextButton.displayName = "IconTextButton";
export default IconTextButton;
//# sourceMappingURL=IconTextButton.js.map